module.exports = __webpack_public_path__ + "img/contract.1ba5dcb9.png";